import Component from './Component';

// A parallax effect that could be applied to some images
// Used by the ImageAndText component if parallax toggled 'on' by content author.

export default class BannerCarousel extends Component {
  load() {
    this.parallaxItems();
    super.load();
  }

  parallaxItems() {

    const parallaxImages = document.querySelectorAll('.imageandtext__img--parallax');
    if (parallaxImages.length == 0) {
      return;
    }

    for (let i = 0; i < parallaxImages.length; i++) {
      const elImage = parallaxImages[i];
      const elFigWindow = elImage.closest('.imageandtext__figure');
      const parentBody = elFigWindow.closest('body'); // iFrame body or page body

      this.imageParallax(elImage, elFigWindow, parentBody);

    }

  }

  imageParallax(elImage, elFigWindow, parentBody) {

    //initial move
    parrallaxMove();

    // const elImage = document.querySelector('.imageandtext__img--parallax');
    // const elFigWindow = document.querySelector('.figwindow'); // TODO: find this from parent of .imageandtext__img--parallax


    function getHeight(el) {
      return el.getBoundingClientRect().bottom - el.getBoundingClientRect().top;
    }


    function getDistanceTop(el) {
      return el.getBoundingClientRect().top;
    }


    function distanceTopAToTopB(elA, elB) {
      return getDistanceTop(elB) - getDistanceTop(elA);
    }


    function distanceBottomTo(el) {
      return el.getBoundingClientRect().bottom;
    }


    addEventListener("scroll", (event) => {
      handleScrollEvent();
    });


    //update translate value on bgimage every second
    function handleScrollEvent() {
      window.requestAnimationFrame(() => parrallaxMove());
    }


    function parrallaxMove() {
      // move image

      let yVal = calcYVal();
      yVal ? elImage.style.transform = `translateY(${yVal}px)` : ''; // early return if empty
      // elImage.style.transform = `translateY(${yVal}px)`;

      // console.log(`yVal:${yVal} distTopToImg:${distanceTopTo(elImage)}, distTopToWindw:${distanceTopTo(elFigWindow)}, distBottomToImg:${distanceBottomTo(elImage)} distBottomToWindw:${distanceBottomTo(elFigWindow)}, imgHt:${getHeight(elImage)}, figWinHt:${getHeight(elFigWindow)}, viewHt:${window.innerHeight}, bodyHt:${getHeight(parentBody)}`);
    }


    function calcYVal() {

      // let info = elFigWindow.closest('.imageandtext').querySelector('.infodebug');
      const imgHt = Math.ceil(getHeight(elImage));
      const figHt = getHeight(elFigWindow);
      const winHt = window.innerHeight;
      const toFigTop = getDistanceTop(elFigWindow);
      const toImgTop = getDistanceTop(elImage);
      const imgMoveAmount = imgHt + figHt;

      const figAboveView = distanceBottomTo(elFigWindow) < 0;
      const figBelowView = toFigTop > winHt;
      // console.log(figAboveView, figBelowView);

      if (figAboveView || figBelowView) {
        return;
      }


      let scrollAmount = winHt + figHt;

      let figWinOffset = calcImageOffset();
      function calcImageOffset() {
        let percent = 0;
        if (toFigTop > -(figHt) && toFigTop < winHt) {  // fig in view
          percent = 100 / scrollAmount * (winHt - toFigTop);
        }
        // console.log('VALUES:', toFigTop, winHt, toImgTop);
        return percent;
      }

      let yOffset = (imgMoveAmount / 100) * figWinOffset;
      // console.log('yOffset px:', Math.round(yOffset * 100) / 100); // 2 decimals
      let yVal = yOffset - imgHt; // start will be negative imgHt

      // let newtext = (`toFigTop: ${Math.round(toFigTop)}, scrollAmount: ${Math.round(scrollAmount)},
      //   <br>winHt-toFigTop: ${Math.round(winHt - toFigTop)}, calc%: ${Math.round(100 / scrollAmount * (winHt - toFigTop))}, wHt:${winHt}
      //   <br>yOffset: ${Math.round(yOffset)}, imgHt: ${Math.round(imgHt)}`);
      // info.innerHTML = newtext;

      // distanceToTopImg should never be greater than 0
      // top of image never lower > than top of fig window
      // bottom of image should never higher < than bottom of figWindow

      // When top of FigWindow at bottom of View then bottom of image should be above FigWindow.
      // When bottom of FigWindow at top of View then top of image should be below FigWindow.

      // TESTS: When figWindow is partially visible above the fold
      //        When zoomed out image offset will fall behind figWindow.
      //        Image could offset at speed of scroll until bot of img reaches bot of figWindow. move in.
      //        Inbetween would use percentage scroll calculation? or choose the lesser offset?
      //        Image could offset at speed of scroll until top of img reaches top of figWindow. move out.

      // console.log(`yVal:${yVal},
      //   distToImg:${getDistanceTop(elImage)},
      //   distToFigWin:${toFigTop},
      //   distImgTopToFigTop:${distanceTopAToTopB(elImage, elFigWindow)},
      //   distBottomToImg:${distanceBottomTo(elImage)}
      //   distBottomToFigWin:${distanceBottomTo(elFigWindow)},
      //   imgHt:${imgHt}, figWinHt:${figHt},
      //   viewHt:${winHt}, bodyHt:${getHeight(parentBody)},
      // `);

      return yVal;  // Math.round(num)
    }

  }
}
